import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useRunRequest } from '@/hooks';
import { TurnResourcesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { OverrideLogicFormFields } from './types';
import { OverrideLogicFormProps } from '../types';

const useController = ({ onClose, selectedIds: selected_ids }: OverrideLogicFormProps) => {
  const { handleSubmit } = useFormContext<OverrideLogicFormFields>();
  const { runRequest } = useRunRequest();
  const { id: workerId } = useParams<{ id: string }>();

  const handleOverride = async (values: OverrideLogicFormFields) => {
    await runRequest({
      fetchType: 'CREATE',
      resource: TurnResourcesEnum.FcraWorkers,
      params: {
        id: workerId,
        target: TurnTargetsEnum.SetOverrideBulk,
        data: { ...values, selected_ids },
      },
      mode: 'notify',
      notify: {
        onError: { message: 'Error: Override was not applied' },
        onSuccess: { message: 'Override applied successfully', postAction: onClose },
      },
    });
  };

  return {
    handleOverride: handleSubmit(handleOverride),
  };
};

export default useController;
